import { render, staticRenderFns } from "./c-btn.vue?vue&type=template&id=13578fcd"
import script from "./c-btn.vue?vue&type=script&lang=js"
export * from "./c-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports